
import { defineComponent } from "vue";

export default defineComponent({
	props: {
		size: {
			type: Number,
			default: 20,
		},
	},
	setup() {
		return {};
	},
});
